import { render, staticRenderFns } from "./SmallBusinesses.vue?vue&type=template&id=1bff0bf8&scoped=true&"
import script from "./SmallBusinesses.vue?vue&type=script&lang=js&"
export * from "./SmallBusinesses.vue?vue&type=script&lang=js&"
import style0 from "./SmallBusinesses.vue?vue&type=style&index=0&id=1bff0bf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bff0bf8",
  null
  
)

export default component.exports